export default __webpack_public_path__ + "static/f29-4a2b5dfb517003493759b23e32592271.svg";